import React, {useMemo, useState} from "react";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {Link} from "react-router-dom";
import axios from "axios";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const [clientName, setClienteName] = useState("ClientName");
  const SETTINGS_URL = `${process.env.REACT_APP_API_URL}/settings/clientname`;
  axios.get(`${SETTINGS_URL}`)
  .then(response => {
    setClienteName(response.data.value);
  })
  .catch({});

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-3 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> | &copy;{" "}
          <a
            href="http://www.solisystems.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            SoliSYSTEMS 
          </a>
        </div>

        <div className="text-dark order-2 order-md-2">
          <span className="mr-1 badge badge-secondary">{clientName}</span>
        </div>

        <div className="nav nav-dark order-1 order-md-3">
          <Link to="/about"
            className="nav-link pr-3 pl-0"
          >
            About
          </Link>
        </div>
      </div>
    </div>
  );
}
